<template>
  <div v-show='cpntMostrar' class="app-cpnt-field cpnt-app-textarea cpnt-app-campo" :class='cpntTextareaMontarClass'>
    <!-- SETA O CAMPO STATUS -->
    <RF-Status v-if='cpntTextareaStatusCampo !== ""' :cpntStatus='cpntTextareaStatusCampo' :cpntTamanho='5'></RF-Status>

    <!-- MOSTRA A TELA -->
    <template v-else-if="value !== '__INICIAL__'">
      <!-- SETA O INPUT -->
      <textarea
      :tabindex="cpntTabIndex"
      autocomplete="off"
      :id="cpntId"
      :disabled="cpntDisabled"
      :maxlength="cpntTextareaMontarMaxLength"
      @keyup.enter='cpntTextareaOnKeyPressEnter'
      @blur='cpntTextareaOnBlur'
      ref="textarea"
      v-model='value'></textarea>

      <!-- SETA A BARRA QUE APRESENTA ABAIXO DO INPUT -->
      <span class="cpnt-barra"></span>
      
      <!-- SETA O TITULO DO CAMPO -->
      <label :for='cpntId' v-if="[ '', null, undefined ].indexOf(cpntNome) === -1 || [ '', null, undefined ].indexOf(cpntExplica) === -1">
        <!-- SETA O NOME DO CAMPO -->
        <span v-if="[ '', null, undefined ].indexOf(cpntNome) === -1" v-html='cpntNome'></span>

        <!-- SETA A EXPLICAÇÃO DO CAMPO -->
        <App-Explica v-if="[ '', null, undefined ].indexOf(cpntExplica) === -1"
          :cpntId='cpntId + "-explica"' 
          :cpntTitle='cpntExplica.mensagem'
          :cpntPositionMy='cpntExplica.posicaoMy'
          :cpntPositionAt='cpntExplica.posicaoAt'
          :cpntClasses='cpntExplica.class'
        ></App-Explica>
      </label>

      <!-- SETA UM AVISO ABAIXO DO CAMPO -->
      <span class="cpnt-has-error" v-if="[ '', null, undefined ].indexOf(cpntMensagem) === -1" v-html='cpntMensagem'></span>
    </template>
  </div>
</template>

<style scoped>
  .cpnt-app-geral > .rf-status {
    text-align: left;
  }
</style>

<style>
  .permissao > table > tr > td.icone,
  .permissao > table > tr > td.mensagem {
    visibility: visible;
  }
    .permissao > table > tr > td.icone > svg {
      font-size: 25px;
    }
</style>

<script>
  export default {
    props: {
      cpntId: {
        required: false,
        type: String,
        default: function () {
          // INICIA A VARIAVEL ID
          var id = ''

          // INICIA PARA VERIFICAR SE ENCONTROU UM ID
          var flag = false

          // PROCURAR A MONTAGEM DO CAMPO
          while (flag === false) {
            // GERA UM ID PARA O CAMPO
            id = 'cpnt-textarea-' + (Math.floor(Math.random() * (9999 - 1000)) + 1000).toString() + '--'

            // VERIFICA SE O ID GERADO É UNICO NA TELA
            flag = [ '', null, undefined ].indexOf(document.getElementById(id)) !== -1
          }

          // RETONAR O VALOR MONTADO
          return id
        }
      },
      cpntStatus: {
        required: false,
        default: function () {
          return ''
        }
      },
      cpntMostrar: {
        type: Boolean,
        required: false,
        default: function () {
          return true
        }
      },
      cpntNome: {
        required: false,
        default: function () {
          return ''
        }
      },
      cpntTabIndex: {
        required: false,
        type: Number,
        default: function () {
          return 0
        }
      },
      cpntExplica: {
        type: Object,
        required: false
      },
      cpntMensagem: {
        type: String,
        required: false,
        default: null
      },
      cpntValue: {
        type: [ String, Number ],
        required: true
      },
      cpntDisabled: {
        type: Boolean,
        required: false,
        default: function () {
          return false
        }
      },
      cpntMask: {
        required: false,
        validator: function (mask) {
          // INICIA O VETOR DE VALORES VALIDOS
          var vetor = [ '', null, undefined, 'chave_acesso', 'telefone', 'cnpj_cpf', 'cep', 'data', 'placa', 'cnpj', 'cpf', 'numero_decimal', 'valor' ]

          // VERIFICA SE A MASCARA TEM UM VALOR VALIDO
          if (vetor.indexOf(mask) === -1) {
            // REMOVE OS VALORES NÃO VALIDOS PARA MENSAGEM
            vetor = vetor.filter(item => [ '', null, undefined ].indexOf(item) === -1)

            // APRESENTA A MENSAGEM DE ERRO
            throw new Error('O valor (' + mask +') informado na chave cpntMask é inválido. Os valores validos são [ ' + vetor.join(', ') + ' ].')
          }
          
          // RETORNA QUE A MASCARA É VALIDA
          return true
        },
        default: function () {
          return null
        }
      },
      cpntMaxLength: {
        type: Number,
        required: false,
        default: function () {
          return 99999999
        }
      },
      cpntMaskPrecision: {
        type: [ Number, Object ],
        required: false,
        default: function () {
          return { min: 2, max: 4 }
        }
      },

      // FUNÇOES DO COMPONENT
      cpntOnChange: {
        required: false,
        default: function () {
          return null
        }
      },
      cpntOnKeyPressEnter: {
        required: false,
        default: function () {
          return null
        }
      },
      cpntOnBlur: {
        required: false,
        default: function () {
          return null
        }
      }
    },
    components: {
      'App-Explica': () => import('@/components/rf-geral/explica/RF-Explica.vue')
    },
    data: function () {
      return {
        value: '__INICIAL__',
        autoDecimalMode: false,
        precisao: { min: 2, max: 4 }
      }
    },
    mounted: function () {
      this.cpntTextareaSetarValue()
    },
    methods: {
      cpntTextareaSetarValue: function () {
        // INICIA O VALOR DA VARIAVEL
        var valor = this.cpntValue

        // CONVERTE O VALOR RECEBIDO
        if ([ 'numero_decimal', 'valor' ].indexOf(this.cpntMask) !== -1 && (this.cpntDisabled === true && this.cpntValue === '') === false) {
          if (typeof valor === 'string' && isNaN(valor) === true) {
            // REMOVE O PONTO
            while (valor.indexOf('.') !== -1) {
              valor = valor.replace('.', '')
            }
            // REMOVE A VIRGULA
            while (valor.indexOf(',') !== -1) {
              valor = valor.replace(',', '')
            }
            
            // CONVERTE O VALOR
            valor = (valor / 100)
          }

          // CONVERTE O VALOR PARA NUMERO
          valor = Number(valor)

          // VERIFICA SE TEM UM VALOR VALIDO
          if ([ '', null, undefined, NaN ].indexOf(valor) !== -1) {
            valor = 0.00
          }

          // VERIFICA A PRECISÃO QUE DEVE PREENCHER
          switch (this.cpntMask) {
            case 'valor':
              this.precisao = { min: 2, max: 2 }
              this.autoDecimalMode = true
              break

            case 'numero_decimal':
              this.precisao = { min: 2, max: 4 }
              this.autoDecimalMode = false
              break
          }
        }

        // SETA O VALOR MONTADO
        this.value = valor
      },
      cpntTextareaOnChangeValue: function () {
        if (this.value !== this.cpntValue) {
          // PEGA O VALOR RECEBIDO
          var valor = this.value

          // VERIFICA SE TEM QUE CONVERTER ALGUM VALOR
          if ([ 'placa' ].indexOf(this.cpntMask) !== -1) {
            valor = valor.toLocaleUpperCase()
          }

          // CHAMA A FUNÇÃO PARA REMOVER OS VALORES
          this.cpntOnChange(valor, this.cpntId)
        }
      },
      cpntRealizarFocus: function (tentativa = 0) {
        if (tentativa <= 10) {
          if (this.cpntMostrar === true && this.cpntTextareaStatusCampo === '') {
            // PEGA O CAMPO SOLICITADO
            var textarea = this.$refs.textarea.$el !== undefined ? this.$refs.textarea.$el : this.$refs.textarea
    
            // REALIZA O FOCUS NO CAMPOS
            textarea.select()

            // IMPORTA A FUNÇÃO QUE SERÁ UTILIZADA
            const FUN_POSICIONAR_SCROLL_FOCUS_CAMPO = require('@/assets/js/Funcoes-Gerais.js').FUN_POSICIONAR_SCROLL_FOCUS_CAMPO

            // EXECUTA A FUNÇÃO IMPORTADA
            FUN_POSICIONAR_SCROLL_FOCUS_CAMPO(textarea)
          } else {
            setTimeout(() => { this.cpntRealizarFocus((tentativa + 1)) }, 250)
          }
        }
      },
      cpntTextareaOnKeyPressEnter: function () {
        if (this.cpntOnKeyPressEnter !== null) {
          this.cpntOnKeyPressEnter(this.cpntId)
        }
      },
      cpntTextareaOnBlur: function () {
        if (this.cpntOnBlur !== null) {
          this.cpntOnBlur(this.cpntId)
        }
      },
    },
    computed: {
      cpntTextareaMontarClass: function () {
        // INICIA O VALOR QUE SERÁ RETORNADO
        var valor = []

        // VERIFICA SE TEM ALGUMA MENSAGEM DE VALIDAÇÃO
        if ([ '', null, undefined ].indexOf(this.cpntMensagem) === -1) {
          valor.push('cpnt-app-campo-has-error')
        }

        if ([ 'placa' ].indexOf(this.cpntMask) !== -1) {
          valor.push('cpnt-input-placa')
        }
        
        // RETORNA O VALOR MONTADO
        return valor
      },
      cpntTextareaStatusCampo: function () {
        // SETA O STATUS DO CAMPO
        var valor = this.cpntStatus

        // VERIFICA SE O VALOR É UM VALOR VALIDO
        if (this.cpntStatus === '' && this.cpntValue.toString().indexOf('#403#') !== -1) {
          valor = this.cpntValue
        }

        // VERIFICA SE DEVE SETAR O STATUS DO CAMPO
        if (this.value === '__INICIAL__') {
          valor = 'carregando'
        }

        // RETORNA O VALOR MONTADO
        return valor
      },
      cpntTextareaMontarMascara: function () {
        switch (this.cpntMask) {
          case '':
          case null:
          case undefined:
            return ''

          case 'chave_acesso':
            return [ '#### #### #### #### #### #### #### #### #### #### ####']

          case 'telefone':
            return [ '(##)####-####', '(##)#####-####' ]

          case 'cnpj_cpf':
            return [ '###.###.###-##', '##.###.###/####-##' ]

          case 'cep':
            return [ '##.###-###' ]

          case 'data':
            return [ '##/##/####' ]

          case 'placa':
            return [ 'AAA#X##' ]

          case 'cnpj':
            return [ '##.###.###/####-##' ]

          case 'cpf':
            return [ '###.###.###-##' ]

          default:
            return []
        }
      },
      cpntTextareaMontarMaxLength: function () {
        switch (this.cpntMask) {
          case 'chave_acesso':
            return 54

          case 'telefone':
            return 15

          case 'cnpj_cpf':
            return 18

          case 'cep':
            return 8

          case 'data':
            return 10

          case 'placa':
            return 7

          case 'cnpj':
            return 18

          case 'cpf':
            return 14

          default: 
            return this.cpntMaxLength
        }
      }
    },
    watch: {
      cpntValue: function () {
        this.cpntTextareaSetarValue()
      },
      value: function () {
        this.cpntTextareaOnChangeValue()
      }
    }
  }
</script>
